export interface ISlicerOption {
  option: string;
  isSelected: boolean;
  labelOverride?: string;
}

export interface ITimeSlicerOption {
  type: TimestampSlicerTypes;
  operands: string[];
}

export enum LegacyTimestampSlicerTypes {
  RANGE = 'RANGE',
  SINCE = 'SINCE',
  BETWEEN = 'BETWEEN',
}

export enum TimestampSlicerTypes {
  CURRENT_AND_PREV = 'CURRENT_AND_PREV',
  IN_PAST = 'IN_PAST',
  SINCE_PERIOD = 'SINCE_PERIOD',
  BETWEEN_PERIOD = 'BETWEEN_PERIOD',
}

export enum SelectStatus {
  ALL = 'all',
  NONE = 'none',
  SOME = 'some',
  SOME_SELECTED = 'some selected',
  SOME_DESELECTED = 'some deselected',
}

export interface ISlicerReducerType {
  hasChanged: boolean;
  selectStatus: SelectStatus;
  allSelected: boolean;
  noneSelected: boolean;
  options: ISlicerOption[];
  loading: boolean;
  searchInput: string;
  reset: () => any;
  isPaged: boolean;
  updateSearchInput: (searchInput: string) => any;
  toggleOption: (option: string) => any;
  selectOnly: (option: string) => any;
  clear: () => any;
  selectAll: () => any;
  save: () => any;
  selectTimeFrame: (option: ITimeSlicerOption) => void;
  isTimestampSlicer: boolean;
  timestampStatusString: string;
}
